const ScreenHeader = (props) => {
  const { title, subText } = props;

  return (
    <div className="mb-4">
      <h1>{title}</h1>
      {subText !== "" ? (
        <div className="d-block">
          <span className="fs-6 text-secondary">{subText}</span>
        </div>
      ) : null}
    </div>
  );
};

export default ScreenHeader;
